const config = {
  devToken: "TO_BE_REMOVED",
};

export default config;
